import React from 'react'

import './OurData.css'

const OurData = () => {
  return (
    <div className='container our-data'>
        <div className='grid-container'>
            <div>
                <h1>14</h1>
                <p>Years of Experience</p>
            </div>

            <div>
                <h1>46</h1>
                <p>Team Members</p>
            </div>

            <div>
                <h1>3</h1>
                <p>Locations</p>
            </div>

            <div>
                <h1>3500+</h1>
                <p>Customers</p>
            </div>
        </div>
    </div>
  )
}

export default OurData